import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {Button} from '@udemy/react-core-components';
import {useUDLink} from '@udemy/ud-data';

import styles from './plan-comparison-faq-value-plan.module.less';

export const PlanComparisonFaqValuePlan = () => {
    const {gettext} = useI18n();
    const udLink = useUDLink();

    return (
        <div className={styles['faq-banner']}>
            <div className={styles['faq-content']}>
                <Icon glyph="quiz" size="medium" className={styles['faq-icon']} label={false} />
                <span className={classNames('ud-text-lg', styles['faq-text'])}>
                    {gettext('Looking for more info? Check out our frequently asked questions.')}
                </span>
            </div>
            <Button
                componentClass="a"
                href={udLink.to('support')}
                udStyle="secondary"
                size="medium"
                target="_blank"
                rel="noopener noreferrer"
                className={styles['faq-button']}
            >
                {gettext('Go to Help Center')}
                <Icon glyph="arrow-right" label={false} />
            </Button>
        </div>
    );
};
